import React from "react";
import FooterFooter from "../../components/footerfooter";
import { StyledHeader } from "../../Styles";
import "./newPage.scss";
//SWITCH VARIABLE FOR PAGE STYLE
const theme = "GREY"; //LIGHT, GREY, RETRO
const NewPage = () => {
  return (
    <div className="greyscheme">
      <StyledHeader theme={theme} />
      <div className="greyscheme">
        <section className="container newpage">
          <div className="side_quests_section">
            <div className="row">
              <div className="col-md-6">
                <div className="img">
                  <div className="img_wrapper left">
                    <img
                      src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/800-pn7uxl6w6vmdeetkimdrxu2hd1w2w3c7w9oqhd9tss.png"
                      className="img800"
                      alt="800"
                    />
                  </div>
                  <div className="img_wrapper">
                    <img
                      src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/250-1-pn7un65afzcypzyccm9msypkcb8mkuzbgpdzzypwrg.png"
                      alt="800"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="content">
                  <h6>How Many Mini Moose Do You Want?</h6>
                  <h2>Side Quests</h2>
                  <button type="button">send a pair on a side quest</button>
                </div>
              </div>
            </div>
          </div>
          <div className="grap_upgrade">
            <div className="row">
              <div className="col-md-6">
                <div className="content">
                  <h6>Hero Box Or Serum?</h6>
                  <h2>Grab An Upgrade</h2>
                  <button type="button">Choose your path</button>
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <div className="img_wrapper">
                    <img
                      src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/2_BoxOpenImage-plxo12ltq5m0trdd8usdvfqvjegzljcxyf9h26zkf0.png"
                      className="img800"
                      alt="800"
                    />
                  </div>
                  <div className="img_wrapper right">
                    <img
                      src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/4_testtube-plxmz2yni7ltl4jy2xm7liv77rpxhxjhqe1zslbdwc.gif"
                      alt="800"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="evolve_mini">
            <div className="row">
              <div className="col-md-6">
                <div className="img">
                  <div className="img_wrapper left">
                    <img
                      src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/F78B74E1-A4C9-4BEE-B506-61D32FC6560A-plz0kyfocgc01ugztvyjxv4y4hdfzhc6lnaukhds0s.jpg"
                      className="img800"
                      alt="800"
                    />
                  </div>
                  <div className="img_wrapper">
                    <img
                      src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/E8427DFF-F3D5-4D0E-83AF-6180DB9D21A2-pp1x91ln6y79jvs913oxh2aosihousn6t89hjsgaak.png"
                      alt="800"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="content">
                  <h6>Which Path Will You Choose?</h6>
                  <h2>Evolve Your Mini</h2>
                  <button type="button">user your upgrade</button>
                </div>
              </div>
            </div>
          </div>
          <div className="snag_hideout">
            <div className="row">
              <div className="col-md-6">
                <div className="content">
                  <h6>Where Are You Going To Build Your Army?</h6>
                  <h2>Snag A Hideout</h2>
                  <button type="button">claim your hideout</button>
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img
                    src="https://moosesocietynft.io/wp-content/uploads/2022/05/D22AE544-BE57-489D-869C-590BC848D324-2048x683.png"
                    alt="800"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <FooterFooter />
    </div>
  );
};

export default NewPage;
